import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import AdminToolsForm from "./components/ToolsForm/AdminToolsForm";

const AdminToolsIndexPage = () => {
	const { t } = useTranslation("admin");
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(`${t("modules.tool.header.title")} | ${t("lib:go_component.navigation.admin")}`);
	}, []);

	return <AdminToolsForm />;
};
export default AdminToolsIndexPage;
